import {AbstractFilterComponent} from "../abstract-filter-component.js";
import {FilterCheckbox} from './checkbox.js';

export class FilterCheckboxList extends AbstractFilterComponent {

	checkboxes = [];

	constructor(parent, filter, node) {
		super(parent, filter, node);
		this.initChildren();
	}

	initChildren() {
		let self = this;

		self.checkboxes = Array.prototype.slice.call(self.node.querySelectorAll(FilterCheckbox.selector)).map(node => {
			return new FilterCheckbox(self, self.filter, node);
		});
	}

	setCheckedState(state) {
		let self = this;

		self.checkboxes.forEach(checkbox => {
			checkbox.setCheckedState(state);
		});
	}

	getLabels() {
		let self = this;

		return self.checkboxes.map(checkbox => {
			return checkbox.getLabel();
		});
	}

	getFormData() {
		let self = this;
		let data = {};

		self.checkboxes.forEach(checkbox => {
			if (checkbox.isChecked()) {
				data[checkbox.getName()] = checkbox.getValue();
			}
		});

		return data;
	}
}
